export default __webpack_public_path__ + "static/media/placeholder_dummy2016-haushalthilfe01-de-mobile.1431a642.png";